import { URL_ROUTES } from '@/constants';
import {
  getWeddingID,
  isWeddingFlow
} from '@/modules/shared/utils/isWeddingFlow';

const getStepPage = (index: number): string => {
  const isWedding = isWeddingFlow();
  const weddingId = getWeddingID();

  if (isWedding) {
    switch (index) {
      case 2:
        return '';
      case 3:
        return URL_ROUTES.WEDDING_BILLING_PATH.replace(':weddingId', weddingId);
      default:
        return URL_ROUTES.WEDDING_PERSONAL_DETAILS.replace(
          ':weddingId',
          weddingId
        );
    }
  }

  switch (index) {
    case 2:
      return '/checkout/shipping';
    case 3:
      return '/checkout/billing';
    default:
      return '/checkout/personal-details';
  }
};

export default getStepPage;
